import React, { memo } from 'react'
import { message, Select, Spin, Empty } from 'antd'
import styled from 'styled-components'
import { debounce } from "../../../utils/utils";
import OpenData from '@/components/open-data/open-data';

const { Option, OptGroup } = Select;

const StyledSelect = styled(Select)`
  width: 240px;
  text-align: left;
  .option-company {
    font-size: 12px;
    color: #BFBFBF;
    margin-left: 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .option-inline{
    display: inline-block;
    width: 132px;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
`

const DeleteLabel = styled.span`
  display: inline-block;
  background: rgba(151, 109, 208, 0.1);  
  color: #976DD0;
  font-size: 12px;
  margin-left: 8px;
  padding: 2px 4px;
`
const OutLabel = styled.span`
  display: inline-block;
  background: #FEF2F7; 
  color: #F77FB3;
  font-size: 12px;
  margin-left: 8px;
  padding: 2px 4px;
`

/**
 * @description type为'group'时表示这是一个组，list字段为一个对象
 * [{label: 'xx', arr: []}, {label: '', arr: []}], label为组名，label为空时作为没有组名的普通项
 * type !== 'group' 时， list为一个普通数组
 */

const CommonSelect = (props) => {
  const { list, placeholder, width, condition, defaultValue = '', checkValue, open, loading = false,
    hasNextPage, handleChange = () => { }, handleConditionChange, reset, allowClear, defaultOpen = false, handleSuccess = () => { }, type, handleBlur = () => { } } = props;
  // 渲染自定义标签
  const ContactState = (props) => {
    if (!props) return null
    const { type, state } = props
    switch (type) {
      case 1:
        return <DeleteLabel>{state}</DeleteLabel>
      case 2:
        return <OutLabel>{state}</OutLabel>
      default:
        return null
    }
  }

  const selectChange = (value) => {
    const obj = value.value && JSON.parse(value.value);
    if (obj.id) {
      handleSuccess({
        value: obj.id,
        name: obj.name
      })
      reset()
    } else {
      message.info("未绑定用户无法选择")
    }
  }
  const popupScrollChange = (e) => { // 下拉分页加载
    if (hasNextPage) {
      const { target } = e;
      const st = target.scrollTop;
      if (st + target.offsetHeight + 10 >= target.scrollHeight) {
        handleConditionChange({
          pageNum: condition.pageNum + 1,
          name: condition.name
        })
      }
    }
  }
  const debounceSearch = debounce(handleSearch, 500);
  function handleSearch(params) {
    handleConditionChange({ pageNum: 1, name: params })
  }

  return (
    <StyledSelect
      style={{ width: width }}
      labelInValue
      virtual={false}
      onSelect={selectChange}
      onChange={debounce(handleChange, 500)}
      onPopupScroll={popupScrollChange}
      placeholder={placeholder || ''}
      showSearch={true}
      onSearch={debounceSearch}
      onBlur={() => handleBlur()}
      allowClear={allowClear}
      defaultOpen={defaultOpen}
      filterOption={false}
      open={open}
      value={checkValue}
      defaultValue={defaultValue || undefined}
      notFoundContent={loading ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      autoFocus={props.autoFocus}
      getPopupContainer={
        triggerNode => {
          return triggerNode.parentNode || document.body;
        }
      }
    >
      {
        type === 'group' && list.map(item => {
          if (item.label && item.arr.length) {
            return <OptGroup label={item.label} key={item.label}>
              {
                item.arr.map(sub => {
                  return <Option key={JSON.stringify({ id: sub.id, name: sub.name })}>
                    <span className={'option-inline'}>
                      <OpenData type="userName" openid={_.get(sub, 'openWxUserid', '')}>
                        {_.get(sub, 'name', '')}
                      </OpenData>
                      {
                        sub.company && <span className={'option-company'}>{'@' + item.company}</span>
                      }
                    </span>
                    {
                      sub.label && <span>{ContactState(sub.label)}</span>
                    }
                  </Option>
                })
              }
            </OptGroup>
          } else {
            return (
              item.arr.map(sub => {
                return <Option key={JSON.stringify({ id: sub.id, name: sub.name })}>
                  <OpenData type="userName" openid={_.get(sub, 'openWxUserid', '')}>
                    {_.get(sub, 'name', '')}
                  </OpenData>
                  {
                    sub.company && <span className={'option-company'}>{'@' + item.company}</span>
                  }
                </Option>
              }
              )
            )
          }
        })
      }
      {
        type !== 'group' && list.map(item => (
          <Option key={JSON.stringify({ id: item.id, name: item.name, extendUserType: item?.extendUserType })}>
            <span className={'option-inline'}>
              <OpenData type="userName" openid={_.get(item, 'openWxUserid', '')}>
                {_.get(item, 'name', '')}
              </OpenData>
              {item.company && <span className={'option-company'}>{'@' + item.company}</span>}
            </span>
          </Option>
        ))
      }
    </StyledSelect>
  )
}
export default memo(CommonSelect)
